import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { Component, Inject } from 'angular-ts-decorators';
import { ProductDifferencesToggleService } from '../services/product-differences.service';

import template from './product-differences-toggle.component.html';

const scrollDelay = 300;

@Component({
  selector: 'productDifferencesToggle',
  template,
})
export class ProductDifferencesToggleComponent {
  public static $inject: ReadonlyArray<string> = [];

  public isToggleOn = false;

  constructor(
    @Inject('productDifferencesToggleService') private readonly productDifferencesToggleService: ProductDifferencesToggleService,
  ) { }

  public onChange(): void {
    this.productDifferencesToggleService.isToggleOn = this.isToggleOn;

    if (this.isToggleOn) {
      setTimeout(() => { this.scrollToElement(); }, scrollDelay);
    }
  }

  public scrollToElement(): void {
    const toolbarElement: HTMLElement | null = document.querySelector('.product-comparison-toolbar__items');
    const highlightedElement: HTMLElement | null = document.querySelector('.product-comparison-row--highlighted');

    if (highlightedElement) {
      smoothScroll(highlightedElement, { offset: toolbarElement?.clientHeight || 0 });
    }
  }
}
